import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import 'bootstrap/dist/css/bootstrap.min.css';
import './theme.css'; // después de Bootstrap: la paleta SISTEMI manda en toda la app
import { HelmetProvider } from 'react-helmet-async';
import { BrowserRouter } from 'react-router-dom';

// La app solo tiene tema claro: limpia la preferencia que guardaba el antiguo modo oscuro.
try { localStorage.removeItem('theme'); } catch {}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <HelmetProvider>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </HelmetProvider>
);
